import React from 'react'
import {
  trackPromotionImpression,
  enablePdpRedesign,
  convertToBoolean,
  isExpressCheckout,
} from 'src/utils'
import { APPConfig } from 'config/appConfig'
import './styles.scss'

const PromotionOverImage = ({ promoOnImageProps, isProductCard = false }) => {
  const { uniquePromotion } = promoOnImageProps || {}

  if (!uniquePromotion || uniquePromotion.length === 0) {
    return null
  }

  let promotionTagStyle = isProductCard
    ? 'plp-promotion-tag'
    : 'pdp-promotion-tag'

  if (isExpressCheckout()) promotionTagStyle += ' express-checkout-promo'
  if (enablePdpRedesign()) promotionTagStyle += ' pdp-redesign'

  let promotionDetails = []
  uniquePromotion.map(promotion => {
    promotionDetails.push({
      id: promotion?.offerId || '',
      name: promotion?.message || '',
    })
  })

  trackPromotionImpression({ promotionDetails })

  const wrapperClass = enablePdpRedesign()
    ? 'position-relative pdp-promotion-tag-wrapper pdp-redesign'
    : 'position-absolute pdp-promotion-tag-wrapper'

  return (
    <div className={wrapperClass}>
      {uniquePromotion.map((promotionDetails, index) => {
        let message =
          promotionDetails?.message || promotionDetails?.displayMessage || ''

        // Apply truncation only if feature flag is enabled
        const enablePromotionTruncation =
          convertToBoolean(
            APPConfig?.getAppConfig()?.enablePromotionTruncation
          ) || false
        if (enablePromotionTruncation) {
          const truncationLimit =
            parseInt(APPConfig?.getAppConfig()?.promotionTruncationLimit, 10) ||
            20
          if (message && message.length > truncationLimit) {
            message = message.slice(0, truncationLimit).concat('...')
          }
        }

        const isBundleDiscount =
          message?.toLowerCase().includes('bundle discount') ||
          message?.toLowerCase().includes('bundle')
        const bundleDiscountClass = enablePdpRedesign()
          ? 'bundle-discount-green'
          : ''

        const textAlignClass = enablePdpRedesign() ? 'text-left' : 'text-center'
        const truncationClass = !enablePromotionTruncation
          ? 'promotion-truncation-disabled'
          : ''

        if (!message || message.trim() === '') {
          return null
        }

        return (
          <div
            key={`promo-${index}`}
            className={`${textAlignClass} ${promotionTagStyle} ${bundleDiscountClass} ${truncationClass}`}
            data-testid="qa-promotion-tag">
            {message}
          </div>
        )
      })}
    </div>
  )
}

export { PromotionOverImage }
export default PromotionOverImage
